import { createContext } from 'react';

const PassengerNameDictContext = createContext()
export default PassengerNameDictContext;